// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__CclC0","spin":"Spinner_spin__u4Q4I"};